import React from "react";

import {NavLink} from 'react-router-dom';

const SideNavReSeller = (pr) => {
    return (
        <div id="layoutSidenav_nav">
            <nav className="sidenav shadow-right sidenav-light">
                <div className="sidenav-menu">
                    <div className="nav accordion" id="accordionSidenav">
                        <NavLink to="/landingReSeller" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-activity"></i></div>
                            Dashboard
                        </NavLink>
                        <NavLink to="/myWishlistReSeller" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-suit-heart-fill"></i></div>
                            My Wishlist
                        </NavLink>
                        <NavLink to="/myCartReSeller" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-suit-heart-fill"></i></div>
                            My Cart
                        </NavLink>
                        <NavLink to="/myOrdersReSeller" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-cart-check-fill"></i></div>
                            My Orders
                        </NavLink>
                        <NavLink to="/artworkReSellerAll" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            My Artworks
                        </NavLink>
                        <NavLink to="/reSellerArtistList" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            My Artists
                        </NavLink>
                       
                        <NavLink to="/viewProfileReSeller" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-cart-check-fill"></i></div>
                            My Profile (Reseller)
                        </NavLink>                       
                    </div>
                </div>

            </nav >
        </div >
    )
}

export default SideNavReSeller;